import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigation } from 'react-router-dom';
import { NavigationContainer } from '@react-navigation/native';
import Navigation from './Navigation';
import EventDetails from './screens/Events/EventDetails';
import AddNewKidRedirect from './screens/Events/AddNewKidRedirect';

const WebNavigation = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (token) {
      sessionStorage.setItem('pendingToken', token);
    }
  }, []);

  // Navigation renders its own NavigationContainer
  return <Navigation />;
};

const WebEventDetails = () => {
  return (
    <NavigationContainer>
      <Routes>
        <Route path="/" element={<EventDetails />} />
        <Route path="/add-new-kid" element={<AddNewKidRedirect />} />
      </Routes>
    </NavigationContainer>
  );
};

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<WebNavigation />} />
        <Route path="/event-details/*" element={<WebEventDetails />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes; 